import React from 'react';
import { Content } from 'rsuite';
import { inventoryLocationsPath } from '../../Paths';
import Breadcrumb from '../../../components/Breadcrumb';
import InventoryLocationForm from '../../../containers/inventory/LocationForm';
import InventoryPageLayout from '../../../containers/inventory/PageLayout';
import PageHeader from '../../../components/PageHeader';

export default () => (
  <InventoryPageLayout>
    <Breadcrumb
      items={[
        {
          path: inventoryLocationsPath,
          label: 'Locations'
        },
        { label: 'Create Location' }
      ]}
    />
    <PageHeader title="Create Location" />
    <Content>
      <InventoryLocationForm />
    </Content>
  </InventoryPageLayout>
);
